import { IField } from 'utils/interfaces/IField';

const menus: IField[] = [];

export default menus;
